import { render } from "./AvisolegalView.vue?vue&type=template&id=bcf250b2&scoped=true"
const script = {}

import "./AvisolegalView.vue?vue&type=style&index=0&id=bcf250b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf250b2"]])

export default __exports__